import { Card, CardProps } from '@mantine/core';
import { clsx } from 'clsx';
import { MouseEventHandler, ReactNode } from 'react';
import { To } from 'react-router-dom';

export type CardDimensions = {
    width?: number | undefined;
};

type CardBaseProps = {
    children?: ReactNode;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component?: any;
    to?: To;
    className?: string;
    onClick?: MouseEventHandler<typeof CardBase> | undefined;
} & CardDimensions
    & CardProps;

export const CardBase = (props: CardBaseProps) => {
    return (
        <Card {...props} className={clsx('p-xl hover:card-clickable relative h-full min-h-44 w-88')}>
            <div className={clsx('h-full w-full', props.className)}>{props.children}</div>
        </Card>
    );
};
